<template>
    <div>
        <app-reviewform v-if="review"
        v-bind:parentObject="{
            review: this.review,
            list: this.list,
            roleName: this.roleName
        }"
        />
    </div>
</template>

<script>

import reviewForm from '../../sscomponents/performance/MyStaffReviewForm.vue';

export default {

    components: {
        'app-reviewform': reviewForm,
    },

    data() {
        return {
            review: this.$route.params.review,
            list: this.$route.params.list,
            roleName: this.$route.params.roleName
        }

        
    },

    methods: {
        
    },

    mounted() {
    }
}

</script>

<style scoped>

</style>